export default "__VITE_ASSET__C83xjWw___"